export default {
  mathTitle: "أدخل الإجابة:",
  regularTitle: "أدخل رمز الأمان"
};
